import {Record, Map} from "immutable"

interface Properties {
    id: number
    name: string
    district: string
}

export class Region extends Record({
    id: undefined,
    name: undefined,
    district: undefined,
}) implements Properties {
    id: number
    name: string
    district: string

    constructor(values: Properties) {
        super(values)
    }
}

export type JsonData =  {
    id: number
    name: string
    district: string
}

export const fromJs = ({
    id,
    name,
    district,
}: JsonData): Region => new Region({
    id,
    name,
    district,
})

export type Regions = Map<number, Region>